export default {
    setSessionValidity(state, payload) {
        console.log('session valid until ' + payload);
        state.session_validity = payload;
    },

    setServerStatus(state, payload) {
        state.server_status = payload;
    },

    appInitialiazed(state, payload) {
        state.initialized = payload.initialized;
    },

    setAuth(state, payload) {
        state.isLoggedIn = payload.isAuth;
        state.userid = payload.userid;
        state.customer = payload.customer;
        state.customerIndicator = payload.customerIndicator;
    },

    setPassword(state, payload) {
        state.newPassword = payload.newpassword;
        state.rePassword = payload.repassword;
    },

    setStoreCatalog(state, payload) {
        state.storeCatalog = payload;
    },

    setStoreConfigID(state, payload) {
        state.storeConfigID = payload;
    },

    setCustomer(state, payload) {
        state.customer = payload;
    },
    setDefaultB2CCustomer(state, payload) {
        state.defaultB2Ccustomer = payload;
    },

    setCustomerDetails(state, payload) {
        state.customerdetails.allowbackorder = payload.allowbackorder;
        state.customerdetails.defaultcarrier = payload.defaultcarrier;
    },

    resetCustomerDetails(state) {
        state.customerdetails =  {
            "allowbackorder": '',
            "defaultcarrier": '',
            "defaultlocationid": '',
            "defaultlocationname": '',
            "defaultlocationcity": '',
            "defaultlocationstate": '',
        };
    },

    setDefaultLocationDetails(state, payload) {
        state.customerdetails.defaultlocationid = payload.defaultlocationid;
        state.customerdetails.defaultlocationname = payload.defaultlocationname;
        state.customerdetails.defaultlocationcity = payload.defaultlocationcity;
        state.customerdetails.defaultlocationstate = payload.defaultlocationstate;
    },

    setUserAttributes(state, payload) {
        state.userAttributes = payload;
    },
    setStorefrontAttributes(state, payload) {
        state.storefrontAttributes = payload;
    },

    setLanguages(state, payload) {
        state.languages = payload;
    },
    
    setErrorFields(state, payload) {
        state.errorFields = payload;
    },
    
    setcustB2BLocations(state, payload) {
        state.custB2BLocations = payload;
    },

    setcustInfoEnrolled(state, payload) {
        state.custInfoEnrolled = payload;
    },

    setmfgs_imgs(state, payload) {
        state.mfgs_imgs = payload;
    },

    setwd_mfgs(state, payload) {
        state.wd_mfgs = payload;
    },

    setwd_mfgxs(state, payload) {
        state.wd_mfgxs = payload;
    },

    setStorefront(state, payload) {
        console.log('setStorefrontAttributes = ' + payload);
        state.storefront = payload;
    },

    setcat_img_level_1(state, payload) {
        state.cat_img_level_1 = payload;
    },

    setcustomerDefaultCC(state, payload){
        state.customerDefaultCC = payload;
    },

    setTypahead_str(state, payload){
        state.typahead_str = payload;
    },

    setSolr_hostname(state, payload){
        state.solr_hostname = payload;
    },

    setSolr_coreadmin(state, payload){
        state.solr_coreadmin = payload;
    },

    setSolr_faceted_filter(state, payload){
        state.solr_faceted_filter = payload;
    },

    setCat_faceted_filter(state, payload){
        state.cat_faceted_filter = payload;
    },

    setSolr_username(state, payload){
        state.solr_username = payload;
    },

    setSolr_password(state, payload){
        state.solr_password = payload;
    },

    setSlider_url(state, payload){
        state.slider_url = payload;
    },

    setRMA_enabled(state, payload){
        state.rma_enabled = payload.ENABLED;
    },

    setDesktop_logo(state, payload){
        state.desktop_logo = payload;
    },

    setMobile_logo(state, payload){
        state.mobile_logo = payload;
    },
}